import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const ModalDeleteProduct = ({ product, deleteProducts }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <button onClick={handleShow} className="btn btn-danger">
        Eliminar
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Esta segura/o que desea eliminar el siguiente producto?
          <br />
          <br />
          {"Nombre: " + product.name + ""}
          <br />
          {"Tipo: " +
            product.typeSelect +
            " en " +
            product.statusSelect +
            " - Disponible: " +
            (product.available ? "Si" : "No")}
          <br />
          {"Precio: " + product.price + " - Moneda: " + product.currencySelect}
          <br />
          {"Terreno: " +
            product.land +
            "m2" +
            " - Construido: " +
            product.built +
            "m2"}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-success" onClick={handleClose}>
            Cancelar
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              deleteProducts(product.id);
            }}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalDeleteProduct;
